import { Skeleton } from '@/components/ui/skeleton'

export function InstructorCardSkeleton() {
  return (
    <div className="rounded-xl border border-gray-100 overflow-hidden shadow-sm">
      {/* Header section */}
      <div className="bg-gradient-to-br from-brand-50 to-teal-50 p-5 pb-4">
        <div className="flex items-start gap-4">
          {/* Avatar */}
          <Skeleton className="h-16 w-16 rounded-full shrink-0" />

          <div className="flex-1 space-y-2">
            {/* Name + badge */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-32 rounded" />
              <Skeleton className="h-4 w-16 rounded-full" />
            </div>
            {/* Location */}
            <Skeleton className="h-3 w-24 rounded" />
            {/* Rating row */}
            <div className="flex items-center gap-2 pt-0.5">
              <Skeleton className="h-3 w-20 rounded" />
              <Skeleton className="h-3 w-16 rounded" />
            </div>
          </div>
        </div>
      </div>

      {/* Content section */}
      <div className="p-5 space-y-3">
        {/* Bio lines */}
        <div className="space-y-1.5">
          <Skeleton className="h-3 w-full rounded" />
          <Skeleton className="h-3 w-4/5 rounded" />
        </div>

        {/* Specialties badges */}
        <div className="flex flex-wrap gap-1.5">
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className="h-5 w-24 rounded-full" />
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>

        {/* Price + button */}
        <div className="flex items-center justify-between pt-2 border-t border-gray-100">
          <div className="space-y-1">
            <Skeleton className="h-2.5 w-10 rounded" />
            <Skeleton className="h-5 w-16 rounded" />
          </div>
          <Skeleton className="h-9 w-24 rounded-md" />
        </div>
      </div>
    </div>
  )
}
